module.exports = __webpack_public_path__ + "static/media/timer-icon.80db29c8.png";